var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "more_horiz"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_369_6053",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_369_6053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "more_horiz_2",
    d: "M6 21.5698C5.45 21.5698 4.97917 21.3534 4.5875 20.9206C4.19583 20.4877 4 19.9674 4 19.3596C4 18.7517 4.19583 18.2314 4.5875 17.7986C4.97917 17.3657 5.45 17.1493 6 17.1493C6.55 17.1493 7.02083 17.3657 7.4125 17.7986C7.80417 18.2314 8 18.7517 8 19.3596C8 19.9674 7.80417 20.4877 7.4125 20.9206C7.02083 21.3534 6.55 21.5698 6 21.5698ZM12 21.5698C11.45 21.5698 10.9792 21.3534 10.5875 20.9206C10.1958 20.4877 10 19.9674 10 19.3596C10 18.7517 10.1958 18.2314 10.5875 17.7986C10.9792 17.3657 11.45 17.1493 12 17.1493C12.55 17.1493 13.0208 17.3657 13.4125 17.7986C13.8042 18.2314 14 18.7517 14 19.3596C14 19.9674 13.8042 20.4877 13.4125 20.9206C13.0208 21.3534 12.55 21.5698 12 21.5698ZM18 21.5698C17.45 21.5698 16.9792 21.3534 16.5875 20.9206C16.1958 20.4877 16 19.9674 16 19.3596C16 18.7517 16.1958 18.2314 16.5875 17.7986C16.9792 17.3657 17.45 17.1493 18 17.1493C18.55 17.1493 19.0208 17.3657 19.4125 17.7986C19.8042 18.2314 20 18.7517 20 19.3596C20 19.9674 19.8042 20.4877 19.4125 20.9206C19.0208 21.3534 18.55 21.5698 18 21.5698Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/MoreIcon.381be1a3f688a21f4d5b9233198abfbb.svg";
export { ForwardRef as ReactComponent };